<script setup>

    import PrimaryButton from '@/Components/Forms/PrimaryButton.vue';
    import { computed, ref, watch } from 'vue';
    import { getOptionName, util } from '@/Helpers';
    import LwxSelect from '@/Components/Forms/LwxSelect.vue';
    import InputLabel from '@/Components/Forms/InputLabel.vue';
    import LwxNumber from '@/Components/Forms/LwxNumber.vue';

    const emit = defineEmits(['close'])

    const props = defineProps({
        client: {
            type: Object,
            required: true
        }
    })

    const genders = [
        {
            id: "male",
            name: "Male"
        },
        {
            id: "female",
            name: "Female"
        }
    ]

</script>

<template>
        <div class="p-5">
            <h2
                class="mb-4 font-bold text-xl text-lifeworx-blue-600"
            >
                Update Vital Statistics
            </h2>

            <div class="grid grid-cols-7 gap-10">
                <div class="col-span-2">
                    <div class="flex flex-col gap-2">
                        <InputLabel
                            for="grid-gender"
                            value="Gender"
                            class="text-xs text-stone-400 whitespace-nowrap w-fit"
                        />
                        <LwxSelect
                            id="grid-gender"
                            v-model="props.client.gender"
                            :options="genders"
                            height="h-10"
                        />
                    </div>
                </div>

                <div class="col-span-3">
                    <div class="flex flex-col gap-2">
                        <InputLabel
                            for="grid-height"
                            value="Height"
                            class="text-xs text-stone-400 whitespace-nowrap w-fit"
                        />
                        <div class="flex gap-4 text-xs">
                            <LwxNumber
                                v-model="props.client.height.foot"
                                unit="foot"
                                :rangeMin=4
                                :rangeMax=7
                            />
                            <LwxNumber
                                v-model="props.client.height.inch"
                                unit="inch"
                                :rangeMin=0
                                :rangeMax=11
                            />
                        </div>
                    </div>
                </div>

                <div class="col-span-2">
                    <div class="flex flex-col gap-2">
                        <InputLabel
                            for="grid-weight"
                            value="Weight"
                            class="text-xs text-stone-400 whitespace-nowrap w-fit"
                        />
                        <div>
                            <LwxNumber
                                v-model="props.client.weight"
                                unit="pound"
                                :rangeMin=75
                                :step=25
                            />
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="mt-5 flex justify-end border-t p-5">

            <PrimaryButton
                class="ml-3"
                @click="emit('close')"
            >
                Done
            </PrimaryButton>
        </div>

</template>
